import {
  SET_FILTER,
  SET_FILTER_SUCCESS,
  SET_FILTER_ERROR,
  REMOVE_FILTER,
  REMOVE_FILTER_SUCCESS,
  REMOVE_FILTER_ERROR
} from './filterSlice';

// Action creators
export const setFilter = (filterData) => ({
  type: SET_FILTER,
  payload: filterData
});

export const setFilterSuccess = (filterData) => ({
  type: SET_FILTER_SUCCESS,
  payload: filterData
});

export const setFilterError = (error) => ({
  type: SET_FILTER_ERROR,
  payload: error
});

export const removeFilter = () => ({
  type: REMOVE_FILTER
});

export const removeFilterSuccess = () => ({
  type: REMOVE_FILTER_SUCCESS
});

export const removeFilterError = (error) => ({
  type: REMOVE_FILTER_ERROR,
  payload: error
});